// extracted by mini-css-extract-plugin
export default {"pricingPlans":"pricingPlans___c992075796f49f04cabf","plans":"plans___f48699723b2d2a47028e"};